import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { popupService } from 'src/app/popup/popup.service';
import { ApiService } from 'src/app/service/api.service';
import { Category, ExtraObject, Recipe } from 'src/Model/Product-Interfaces';
import {
  countRequiredExtraGroups,
  popupData,
  toRenderedExtraList,
} from 'src/app/popup/popup.service';
import { SelectDeliveryType } from '../select-delivery-type/select-delivery-type.service';
import { Subscription } from 'rxjs';
import { RequestService } from 'src/app/service/request.service';
import { PosthogService } from 'src/app/analytics/services/posthog.service';
@Component({
  selector: 'app-recipe',
  templateUrl: './recipe.component.html',
  styleUrls: ['./recipe.component.scss'],
})
export class RecipeComponent implements OnInit, OnDestroy {
  showPopup = false;
  @Input() recipes: Partial<Recipe>[] = [];
  @Input() category: Category;
  @Input() openForNonExtras: boolean = false;
  @Input() addTocart: boolean = true;
  @Input() dineIn: boolean = false;
  @Input() doNotOpenDeliveryPopup: boolean = false;
  @Input() isPromotedItem: boolean = false;
  @Input() showImage: boolean = true;

  LandingPostcodeValidation: boolean;

  /* Select Delivery type */
  selectDeliveryType: boolean = false;
  DeliveryFrom;
  MinDeliveryTime;
  CollectionFrom;
  MinCollectionTime;
  /* Styles */
  ItemTitleColor;
  ItemDescriptionColor;
  ItemBackgroundColor;
  MenuCartColor: string;
  RecipePriceTextColor: string;
  RecipePriceBackgroundColor: string;
  RecipePriceBorderColor: string;
  SelectedButtonColor: string;
  SelectedButtonTextColor: string;
  deliveryTypePopup: boolean;
  outOfStockLabelText: string;
  CurrencySymbol: string;

  RecipeOldPriceText: string = 'Before';
  RecipeNewPriceText: string = 'Now';
  RecipeOldPriceTextColor: string = '#696868';

  RecipeDiscountLabelBGColor: string = '#198754';
  RecipeDiscountLabelTextColor: string = 'white';

  recipeToAdd: Recipe;
  categoryToAdd: Category;

  subs: Subscription[] = [];
  constructor(
    private apiService: ApiService,
    private _requestService: RequestService,
    private popupService: popupService,
    private selectService: SelectDeliveryType,
    private posthog: PosthogService
  ) {}

  ngOnInit(): void {
    const deliveryMap = {
      EatIn: 'ForEatIn',
      Store: 'ForCollection',
      Home: 'ForDelivery',
    } as const;

    const sub = this._requestService.deliveryType$.subscribe((type) => {
    
      if (!type || !this.recipeToAdd || !this.categoryToAdd) return;

      const key = deliveryMap[type];
      if (!key) return;

      if (this.categoryToAdd[key] && this.recipeToAdd[key]) {
        this.getRecipeModal(this.recipeToAdd);
      }
    });

    this.subs.push(sub);

    this.getWebCustomer();
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }

  getWebCustomer() {
    const sub = this.apiService.getWebcustomer$.subscribe((res) => {
      if (!res) {
        return;
      }

      this.CurrencySymbol = res.TemplateData.CurrencySymbol || 'GBP';

      this.outOfStockLabelText = res.TemplateData?.Menu?.OutOfStockLabelText;
      this.deliveryTypePopup = res.TemplateData?.DeliveryTypes?.Enabled;

      this.ItemBackgroundColor =
        res.TemplateData.DynamicStyle.SecondaryColors?.ItemBackgroundColor;
      this.ItemDescriptionColor =
        res.TemplateData.DynamicStyle.SecondaryColors?.ItemDescriptionColor;
      this.ItemTitleColor =
        res.TemplateData.DynamicStyle.SecondaryColors?.ItemTitleColor;
      this.LandingPostcodeValidation =
        res.TemplateData.CheckoutDetail?.LandingPostcodeValidation;
      this.SelectedButtonColor =
        res.TemplateData.DynamicStyle.SecondaryColors.SelectedButtonColor;
      this.SelectedButtonTextColor =
        res.TemplateData.DynamicStyle.SecondaryColors.SelectedButtonTextColor;
      this.MenuCartColor =
        res.TemplateData.DynamicStyle.SecondaryColors.MenuCartColor;

      this.RecipePriceTextColor =
        res.TemplateData.DynamicStyle.SecondaryColors.RecipePriceTextColor;

      this.RecipePriceBackgroundColor =
        res.TemplateData.DynamicStyle.SecondaryColors.RecipePriceBackgroundColor;

      this.RecipePriceBorderColor =
        res.TemplateData.DynamicStyle.SecondaryColors.RecipePriceBorderColor;

      this.RecipeOldPriceText =
        res.TemplateData?.Menu?.DiscountedItemsSettings.Recipe.RecipeOldPriceText;

      this.RecipeNewPriceText =
        res.TemplateData?.Menu?.DiscountedItemsSettings.Recipe.RecipeNewPriceText;

      this.RecipeOldPriceTextColor =
        res.TemplateData?.Menu?.DiscountedItemsSettings.Recipe.RecipeOldPriceTextColor;

      this.RecipeDiscountLabelBGColor =
        res.TemplateData?.Menu?.DiscountedItemsSettings.Recipe.RecipeDiscountLabelBGColor;

      this.RecipeDiscountLabelTextColor =
        res.TemplateData?.Menu?.DiscountedItemsSettings.Recipe.RecipeDiscountLabelTextColor;
    });
    this.subs.push(sub);
  }

  getRecipeModal(recipe: Partial<Recipe>) {
    this.recipeToAdd = null;
    this.categoryToAdd = null;
    this.posthog.captureEvent('Item_Add_to_Cart_Clicked', {
      RecipeId: recipe.RecipeId,
      RecipeTitle: recipe.RecipeTitle,
      Category: recipe.CategoryTitle,
      Unit_price: recipe.RecipePrice,
    });

    if (
      !this.doNotOpenDeliveryPopup &&
      this.deliveryTypePopup &&
      !this._requestService.deliveryType$.value.length
    ) {
      this.selectService.showPopup.next();
      this.posthog.captureEvent('Select Delivery Types Popup Opens', {
        RecipeId: recipe.RecipeId,
        RecipeTitle: recipe.RecipeTitle,
      });

    
      this.recipeToAdd = recipe as Recipe;
      this.categoryToAdd = this.category;
      return;
    }

    let renderedExtraList: Array<any> = [];
    let renderExtralistChooseOnes = 0;
    let extras: ExtraObject = recipe.RecipeExtraObject;

    if (!extras) {
      let popupdata: popupData = {
        MenuBuilder: extras?.MenuBuilder,
        eatIn: recipe.ForEatIn,
        dineIn: this.dineIn,
        filteredProduct: null,
        filteredRecipe: recipe,
        renderedExtraList: renderedExtraList,
        openForNonExtras: this.openForNonExtras,
        renderExtralistChooseOnes: renderExtralistChooseOnes,
        mergePopups: extras?.mergePopups,
        renderedMenuBuilder: extras?.Sections,
        isPromotionItem: this.isPromotedItem,
        PromotionItemId: recipe.PromotionItemId,
      };
      this.popupService.popUpData.next(popupdata);

      return;
    }

    if (typeof extras == 'string') {
      extras = JSON.parse(extras);
    }

    if (extras?.MenuBuilder && !extras.mergePopups) {
      renderedExtraList = extras?.Sections;
    } else {
      // builds the groups (with MaxQuantity) the popup resolves selection criteria on by key
      // (menu-builder `Sections` are skipped by the helper when popups are merged)
      renderedExtraList = toRenderedExtraList(extras);
      renderExtralistChooseOnes = countRequiredExtraGroups(renderedExtraList);
    }

    let popupdata: popupData = {
      MenuBuilder: extras?.MenuBuilder,
      eatIn: recipe.ForEatIn,
      dineIn: this.dineIn,
      filteredProduct: null,
      filteredRecipe: recipe,
      renderedExtraList: renderedExtraList,
      openForNonExtras: this.openForNonExtras,
      renderExtralistChooseOnes: renderExtralistChooseOnes,
      mergePopups: extras?.mergePopups,
      renderedMenuBuilder: extras?.Sections,
      isPromotionItem: this.isPromotedItem,
      PromotionItemId: recipe.PromotionItemId,
    };

    this.popupService.popUpData.next(popupdata);
  }
}
